<template>
  <ContainerBasic container-type="FULL_WIDTH">
    <HeadlineDynamic
      :has-decoration="true"
      :headline="
        blockData && blockData.headline
          ? blockData.headline
          : t('accordionFaqs.defaultHeadline')
      "
      level="h2"
    />
    <ContainerBasic
      container-type="PAGE"
      class="wysi-faq-accordion mt-md md:mt-xl px-sm xl:px-0"
    >
      <div class="flex flex-col touch:md:flex-row lg:flex-row">
        <div class="basis-1/2">
          <AccordionMulti
            :accordion-items="blockData.accordion"
            :content-type="EAccordionContentType.WYSIWYG"
          />
        </div>
        <!--Person Tile -->
        <div
          v-if="person"
          class="flex justify-center basis-1/2 pt-sm px-md lg:pt-0"
        >
          <div class="flex flex-col max-w-sm">
            <AvatarIcon
              class="mx-auto"
              :size="EAvatarSize.lg"
              :image="blockData.personBlock.person.image.desktop.url"
            />
            <div class="flex flex-col items-center">
              <div class="mb-2 text-center mt-sm">
                <div class="font-bold">
                  {{
                    person.title
                      ? `${person.title} ${person.firstName} ${person.lastName}`
                      : `${person.firstName} ${person.lastName}`
                  }}
                </div>
                <div v-if="person.profession || person.jobPosition">
                  <span v-if="person.profession">{{ person.profession }}</span>
                  <span v-if="person.profession && person.jobPosition">
                    |
                  </span>
                  <span v-if="person.jobPosition">{{
                    person.jobPosition
                  }}</span>
                </div>
              </div>

              <div v-if="blockData.personBlock.showContactData && person.phone">
                <FaIcon icon-class="fal fa-phone" classes="mr-xs" />
                <a :href="`tel:${person.phone}`">{{ person.phone }}</a>
              </div>
              <div v-if="blockData.personBlock.showContactData && person.email">
                <PersonMail :mail="person.email" :is-bold="false" />
              </div>

              <div v-if="blockData.quote" class="pt-sm">
                {{ blockData.quote }}
              </div>
              <p
                v-if="blockData.personBlock.showVMVLogo"
                class="text-center mt-sm"
              >
                <img
                  alt="Von Mensch Zu Mensch Logo"
                  src="@/assets/images/TEMP-von-mensch-zu-mensch.png"
                  class="w-[185px] mx-auto"
                  loading="lazy"
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </ContainerBasic>
  </ContainerBasic>
</template>

<script setup lang="ts">
import { EAvatarSize } from '@/@types/avatar-icon';
import { EAccordionContentType } from '@/@types/accordion';
import ContainerBasic from '@/components/components/container-basic.vue';
import AccordionMulti from '@/components/components/core/accordion/vdv/accordion-multi.vue';
import AvatarIcon from '@/components/components/core/avatar-icon.vue';
import HeadlineDynamic from '@/components/components/core/headline-dynamic/vdv/headline-dynamic.vue';
import PersonMail from '@/components/components/person-mail.vue';
import type { AccordionFAQsData } from '../blockType';
import FaIcon from '@/components/fa-icon.vue';

const { t } = useTrans();

const props = defineProps({
  blockData: {
    type: Object as PropType<AccordionFAQsData>,
    required: true,
    default: {} as AccordionFAQsData,
  },
});

const person = props.blockData.personBlock?.person ?? null;
</script>
